import { render } from "./LearningPlanDrawerOverview.vue?vue&type=template&id=e460b1be&scoped=true"
import script from "./LearningPlanDrawerOverview.vue?vue&type=script&lang=js"
export * from "./LearningPlanDrawerOverview.vue?vue&type=script&lang=js"

import "./LearningPlanDrawerOverview.vue?vue&type=style&index=0&id=e460b1be&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e460b1be"]])

export default __exports__